import React, {useState, useEffect, useContext} from 'react';
import Navbar1 from './Navbar1';
import Sidebar from '../admin/components/sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {pdfjs} from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { useTranslation } from 'react-i18next';
import {
    serverTimestamp,
    addDoc,
    doc,
    getDoc,
    collection
  } from "firebase/firestore";
import { db, storage } from "../../firebase";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { reset } from '../../features/auth/authSlice';
import { AuthContext } from "../../context/AuthContext";
import config from '../../config';
import emailController from '../../controllers/emailController';

var url = config.nav.url;

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
let id = '';
const Report = () => {
    const { t } = useTranslation();
    if(localStorage.getItem('id') != null){
        id = localStorage.getItem('id');
    }

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {currentUser} = useContext(AuthContext);
    const [user, setUser] = useState({
        id: '',
        title : '',
        grade : '',
        lastName: '',
        firstName: '',
        email: '',
        phone: '',
        whatsapp: '',
        theme: ''
    });
    let [firstRender, setFirstRender] = useState({
        firstRender: true,
    });
    const [isLoading, setIsLoading] = useState(false);
    var today = Date();
    var lastDay = '01/30/2023';

    // submissions
    const [evaluation, setEvaluation] = useState("");
    const [summary, setFileSummary] = useState("");

    const getUserDetails = async () => {
        try {
            const userRef = doc(db, "users", id);
            const userSnap = await getDoc(userRef);
            
            if(userSnap.exists()){
            return userSnap.data();
            }
        } catch (error) {
            window.alert(error)
        }
    };
    

    useEffect(() => {
        if(firstRender){
            getUserDetails().then(data => {
                setUser(data);
                setFirstRender(false);
            });
        }
        
        dispatch(reset())
  }, [dispatch])

    // Handle Submit
    const handleSubmit = async (event) => {
        event.preventDefault();
        if(window.confirm("Voulez-vous enregistrer votre rapport ?")){
            setIsLoading(true);
            // save reports
            try {
                // save user documents
                await Promise.all(
                    [summary].map(async file => {
                      const fileName = `${file.name}`;
                      const storageRef = ref(storage, `files/report/${id}/${fileName}`);
                      try {
                        uploadBytes(storageRef, file).then((snapshot) => {
                            getDownloadURL(snapshot.ref).then( async (downloadURL) =>{
                                const item = {
                                    url: downloadURL,
                                    path: fileName,
                                    uploadedAt: serverTimestamp(),
                                };
                                await addDoc(collection(db, `users/${id}/summary`), {
                                    ...item
                                });
                            });
                        });
                        
                      } catch (e) {
                        window.alert('Une erreur a été produite !');
                      }
                    })
                  );
                  await Promise.all(
                    [evaluation].map(async file => {
                      const fileName = `${file.name}`;
                      const storageRef = ref(storage, `files/report/${id}/${fileName}`);
                      try {
                        uploadBytes(storageRef, file).then((snapshot) => {
                            getDownloadURL(snapshot.ref).then( async (downloadURL) =>{
                                const item = {
                                    url: downloadURL,
                                    path: fileName,
                                    uploadedAt: serverTimestamp(),
                                };
                                await addDoc(collection(db, `users/${id}/evaluation`), {
                                    ...item
                                });
                            });
                        });
                        
                      } catch (e) {
                        window.alert('Une erreur a été produite !');
                      }
                    })
                  );
                await emailController.sendEmailToExam(user).then(ans => {
                    if(ans){
                        window.alert('Rapport enregistré avec succès !');
                        navigate("/dashboard");
                    }
                    else{
                        window.alert('Une erreur est survenue, veuillez essayer plus tard !');
                    }
                })
            } catch (error) {
                setIsLoading(false);
                if(error.toString().includes("offline")){
                    window.alert('Pas de connexion internet')
                }
                else{
                    window.alert(error)
                }
            }
        }
    }

    return (
        <div className='home'>
            <Sidebar/>
            <div className="homeContainer">
            <Navbar1/>
                <div className="row">
                    <div className="col-md-8 p-4">
                                <div className="cadre p-4">
                                    <h2>{t('evaluation_report')} </h2>
                                    <br />
                                    <form onSubmit={()=>{}}>
                                        <div className="formInput">
                                            <label htmlFor="file">
                                                <span className={summary !== undefined &&  summary.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('summary_sheet')}:</span> &nbsp;
                                            </label>
                                            <input
                                            type="file"
                                            id="submitForm"
                                            accept='.pdf'
                                            
                                            onChange={(e) => setFileSummary(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <div className="formInput">
                                            <label htmlFor="file">
                                            <span className={evaluation !== undefined &&  evaluation.length   < 1?
                                                            'error'
                                                                :
                                                            'fw-bolder text-success'
                                                }>{t('evaluation_sheet')}:</span> &nbsp; 
                                            </label>
                                            <input
                                            type="file"
                                            id="attestation"
                                            accept='.pdf'
                                            onChange={(e) => setEvaluation(e.target.files[0])}
                                            />
                                        </div>
                                        <br />
                                        <br /><br />
                                        <div className="ms-4">
                                            <input type="submit" disabled={
                                                (summary.length < 1 || evaluation.length) 
                                            } className='btn btn-outline-primary'  id="vehicle1" name="vehicle1" value={t('submit')} onClick={handleSubmit}/>
                                        </div>
                                    </form>
                                </div>
                    </div>
                </div>
                <div className="space"/>
            </div>
        </div>
    )
}

export default Report;
